import { render, staticRenderFns } from "./InvoiceInboundsAccountant.vue?vue&type=template&id=1d94e651&"
import script from "./InvoiceInboundsAccountant.vue?vue&type=script&lang=js&"
export * from "./InvoiceInboundsAccountant.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInboundsAccountant.vue?vue&type=style&index=0&%40scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports